import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { Typography } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid";

const renderStatus = (status: boolean) => {
  const statusLabel = status ? "Active" : "Inactive";
  const colors: { [index: string]: "success" | "default" } = {
    Active: "success",
    Inactive: "default",
  };

  return <Chip label={statusLabel} color={colors[statusLabel]} size="small" />;
}

const renderType = (type: string) => {
  const typeName = type.toLowerCase();
  const formattedName = typeName.charAt(0).toUpperCase() + typeName.slice(1);
  return <Typography>{formattedName}</Typography>;
};

export const renderAvatar = (
  params: GridCellParams<{ name: string; color: string }, any, any>
) => {
  if (params.value == null) {
    return "";
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: "24px",
        height: "24px",
        fontSize: "0.85rem",
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export const columns: GridColDef[] = [
  { field: "clientName", headerName: "Client Name", flex: 1.5, minWidth: 200 },
  {
    field: "clientEmail",
    headerName: "Client Email",
    flex: 1.5,
    minWidth: 200,
  },
  {
    field: "status",
    headerName: "Status",
    flex: 0.5,
    minWidth: 80,
    renderCell: (params) => renderStatus(params.value as any),
  },

  {
    field: "type",
    headerName: "Type",
    headerAlign: "right",
    align: "right",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => renderType(params.value as any),
  },
];
